import defaultLoader from './lottie/purp_small.json'
import mfLoader from './lottie/rotate_loader.json';

import './lottie/lottie.css';
import Lottie from 'react-lottie';


const LottieLoader = ({label, layer}) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: (label === "MF") ? mfLoader: defaultLoader,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        },
    };
    const settings = {
        height: 300,
        width: 300,
        isClickToPauseDisabled: true
    }
    return (
        <div className={`Lottie-main App ${(layer === "top") ? 'Lottie-top-transparent' : 'Lottie-blackout bg-white'}`}>
            <Lottie
                options={defaultOptions}
                isClickToPauseDisabled = {settings.isClickToPauseDisabled}
                height={settings.height}
                width={settings.width}
            />
        </div>
    );
}

export default LottieLoader